
const KCAKuma = () => {

  return (
    <div className="w-full min-h-screen bg-white">
      <div className="relative bg-[#14532d] text-white py-8 md:py-10 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight uppercase tracking-tight">
             Kings C. Akuma
          </h2>
        </div>
      </div>
      <div className="max-w-5xl mx-auto px-4 py-8 font-sans text-gray-800">

        <div className="bg-black text-white p-6 md:p-10 mb-6 shadow-xl rounded-3xl">
          <p className="text-lg md:text-xl leading-relaxed font-medium italic">
            Pst Akuma Chairs the Board Credit Committee of Fidelity Bank and had also Chaired the Board Corporate Governance Committee.        </p>
        </div>
        <section>
          <div className="max-w-6xl mx-auto p-8 bg-white font-sans text-gray-700">
            <div className="flex flex-col md:flex-row gap-12">

              {/* Left Side: Image */}
              <div className="md:w-1/3">
                <div className="sticky top-24">
                  <div className="relative group">
                    <div className="absolute -inset-1 bg-gradient-to-r from-green-700 to-yellow-400 rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>
                    <img
                      src="/images/KC-Akuma.jpg"
                      alt="Kings C. Akuma"
                      className="relative w-full h-auto object-cover rounded-2xl shadow-2xl border-4 border-white"
                    />
                  </div>

                  <div className="mt-8 p-6 bg-gray-50 rounded-2xl border border-gray-100">
                    <h4 className="text-xs font-black text-green-700 uppercase tracking-widest mb-4">Core Expertise</h4>
                    <div className="flex flex-wrap gap-2">
                      {['Banking', 'Oil & Gas', 'Consulting', 'Forensic Accounting'].map(tag => (
                        <span key={tag} className="px-3 py-1 bg-white border border-gray-200 rounded-full text-[10px] font-bold text-gray-600">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Side: Content */}
              <div className="md:w-2/3">
                {/* Name and Title */}
                <header className="mb-12">
                  <h1 className="text-4xl font-black text-black mb-6 uppercase tracking-tight">Biography</h1>
                  <div className="text-lg leading-relaxed space-y-6 text-gray-600 font-medium">
                    <p>
                      Pst Akuma is a <span className="text-green-700 font-bold">Fellow of both the Institute of Chartered Accountants of Nigeria</span>, and the Chartered Institute of Taxation of Nigeria. He coordinated comprehensive financial due diligence on several banks and has over three decades of in-depth understanding of banking/finance operations, consulting, manufacturing, oil & gas, due diligence and forensic accounting. Pst Akuma is a Member of the Institute of Chartered Mediators and Conciliators, as well as a Fellow of the Nigerian Institute of Credit Administration.
                    </p>
                    <p>
                      Pst Akuma Chairs the Board Credit Committee of Fidelity Bank and had also Chaired the Board Corporate Governance Committee. He is also a member of the Board Finance & General Purpose Committee, Board Audit Committee, Board Risk Committee, as well as the Shareholders Audit Committee.
                    </p>
                  </div>
                </header>

                <hr className="border-gray-100 mb-12" />

                {/* Experience Section */}
                <section className="flex flex-col sm:flex-row gap-8 mb-16">
                  <div className="w-full sm:w-32 shrink-0">
                    <h2 className="text-xl font-black text-black uppercase tracking-tighter">Experience</h2>
                    <div className="w-10 h-1 bg-yellow-400 mt-2"></div>
                  </div>
                  <div className="flex-1 space-y-10">
                    {/* Item 1 */}
                    <div className="relative pl-8 border-l-2 border-green-700">
                      <div className="absolute w-4 h-4 bg-yellow-400 rounded-full -left-[9px] top-1 border-4 border-white"></div>
                      <h3 className="font-black text-black uppercase">Non-Executive Director</h3>
                      <p className="text-sm text-green-700 font-bold italic">Fidelity Bank PLC, Lagos, Nigeria</p>
                      <p className="text-[10px] text-gray-400 mt-2 font-black uppercase tracking-widest">Nov 2016 – to date</p>
                    </div>

                    {/* Item 2 */}
                    <div className="relative pl-8 border-l-2 border-green-700">
                      <div className="absolute w-4 h-4 bg-yellow-400 rounded-full -left-[9px] top-1 border-4 border-white"></div>
                      <h3 className="font-black text-black uppercase">Chairman</h3>
                      <p className="text-sm text-green-700 font-bold italic">Benin Electricity Distribution Company</p>
                      <p className="text-[10px] text-gray-400 mt-2 font-black uppercase tracking-widest">July 2022 till date</p>
                    </div>

                    {/* Item 3 */}
                    <div className="relative pl-8 border-l-2 border-green-700">
                      <div className="absolute w-4 h-4 bg-yellow-400 rounded-full -left-[9px] top-1 border-4 border-white"></div>
                      <h3 className="font-black text-black uppercase">Managing Director</h3>
                      <p className="text-sm text-green-700 font-bold italic">Akvidson Engineering & Construction Ltd., Port Harcourt, Nigeria</p>
                      <p className="text-[10px] text-gray-400 mt-2 font-black uppercase tracking-widest">Jun 2020 – to date</p>
                    </div>

                    <div className="relative pl-8 border-l-2 border-green-700">
                      <div className="absolute w-4 h-4 bg-yellow-400 rounded-full -left-[9px] top-1 border-4 border-white"></div>
                      <h3 className="font-black text-black uppercase">Managing Director</h3>
                      <p className="text-sm text-green-700 font-bold italic">Hedo-Bec Engr & Constr. Ltd., Port Harcourt, Nigeria
                      </p>
                      <p className="text-[10px] text-gray-400 mt-2 font-black uppercase tracking-widest">Aug 2019 – to date
                      </p>
                    </div>

                    <div className="relative pl-8 border-l-2 border-green-700">
                      <div className="absolute w-4 h-4 bg-yellow-400 rounded-full -left-[9px] top-1 border-4 border-white"></div>
                      <h3 className="font-black text-black uppercase">Managing Director</h3>
                      <p className="text-sm text-green-700 font-bold italic"> AccessPro Technologies Ltd, Port Harcourt, Nigeria</p>
                      <p className="text-[10px] text-gray-400 mt-2 font-black uppercase tracking-widest">Aug 2021 – to date</p>
                    </div>


                    <div className="relative pl-8 border-l-2 border-green-700">
                      <div className="absolute w-4 h-4 bg-yellow-400 rounded-full -left-[9px] top-1 border-4 border-white"></div>
                      <h3 className="font-black text-black uppercase"> General Manager</h3>
                      <p className="text-sm text-green-700 font-bold italic">Alcon Nigeria Ltd., Port Harcourt, Nigeria</p>
                      <p className="text-[10px] text-gray-400 mt-2 font-black uppercase tracking-widest">Feb 2016 – to June 2020 </p>
                    </div>

                    <div className="relative pl-8 border-l-2 border-green-700">
                      <div className="absolute w-4 h-4 bg-yellow-400 rounded-full -left-[9px] top-1 border-4 border-white"></div>
                      <h3 className="font-black text-black uppercase">Area Manager</h3>
                      <p className="text-sm text-green-700 font-bold italic">Alcon Nigeria Ltd., Port Harcourt, Nigeria </p>
                      <p className="text-[10px] text-gray-400 mt-2 font-black uppercase tracking-widest">Sep 2015 – Jan 2016</p>
                    </div>

                    <div className="relative pl-8 border-l-2 border-green-700">
                      <div className="absolute w-4 h-4 bg-yellow-400 rounded-full -left-[9px] top-1 border-4 border-white"></div>
                      <h3 className="font-black text-black uppercase">Managing Director</h3>
                      <p className="text-sm text-green-700 font-bold italic">Hammakopp Consortium Ltd (An affiliate of Nestoil Group Plc, Lagos)                </p>
                      <p className="text-[10px] text-gray-400 mt-2 font-black uppercase tracking-widest">Aug 2011 – Sept. 2015</p>
                    </div>

                    <div className="relative pl-8 border-l-2 border-green-700">
                      <div className="absolute w-4 h-4 bg-yellow-400 rounded-full -left-[9px] top-1 border-4 border-white"></div>
                      <h3 className="font-black text-black uppercase"> Director, Operations & Quality</h3>
                      <p className="text-sm text-green-700 font-bold italic">Nestoil Plc, Port Harcourt, Nigeria</p>
                      <p className="text-[10px] text-gray-400 mt-2 font-black uppercase tracking-widest">Jun 2008 – Jul 2011                </p>
                    </div>

                  </div>
                </section>

                <hr className="border-gray-100 mb-12" />

                {/* Education Section */}
                <section className="flex flex-col sm:flex-row gap-8 mb-16">
                  <div className="w-full sm:w-32 shrink-0">
                    <h2 className="text-xl font-black text-black uppercase tracking-tighter">Education</h2>
                    <div className="w-10 h-1 bg-yellow-400 mt-2"></div>
                  </div>
                  <div className="flex-1 space-y-10">
                    <div className="p-6 bg-gray-50 rounded-2xl border-l-4 border-green-700">
                      <h3 className="font-black text-black uppercase">Bachelor of Accounting</h3>
                      <p className="text-sm text-gray-600 font-bold">University of Nigeria, Nsukka, Nigeria</p>
                      <p className="text-xs text-gray-400 mt-2 font-black">1980 – 1984</p>
                    </div>

                    <div className="p-6 bg-gray-50 rounded-2xl border-l-4 border-green-700">
                      <h3 className="font-black text-black uppercase">Master of Business Administration (MBA)</h3>
                      <p className="text-sm text-gray-600 font-bold">University of Lagos, Lagos, Nigeria</p>
                      <p className="text-xs text-gray-400 mt-2 font-black">1991 – 1993</p>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default KCAKuma;